'use strict';
var PHONE_REGEXP = /^([0-9\(\)\/\+ \-]*)$/;

class PhoneDirective {
    restrict = 'A';
    require = 'ngModel';

    link(scope, element, attrs, ngModelCtrl) {
        ngModelCtrl.$parsers.push((viewValue) => {
            if (PHONE_REGEXP.test(viewValue)) {
                ngModelCtrl.$setValidity('phone', true);
                return viewValue;
            }
            ngModelCtrl.$setValidity('phone', false);
            return undefined;
        });
    }
}

export let phone:any = () => new PhoneDirective();


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/validation/phone.directive.ts